


















































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import TestQuestion from "@/store/entities/testQuestion";

class PageImportSisterQuestionRequest extends PageRequest {
  keyword: string;
  classTypeId: number = 3;
  GradeType: number = 0;
  multiTypeName: string = "章节";
  parentId?: number;
  parentName: string = "上级分类";
  sectionId?: number;
  questionType: number = 0;
  isAudit: string = null;
  sisterId: string;
  isImportSister: boolean = true;
}

@Component({
  components: {},
})
export default class ImportSisterQuestions extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  edit() {
    this.editSisterModalShow = true;
  }
  //filters
  pagerequest: PageImportSisterQuestionRequest =
    new PageImportSisterQuestionRequest();
  editSisterModalShow: boolean = false;
  screenWidth: number = document.body.clientWidth - 200;
  question: TestQuestion = new TestQuestion();
  sisterIds: any = [];
  multiTypes: any = [];
  data: any = [];
  showme: string = "测试";
  valueArray: any = [];
  IsAuditList: any = [
    { value: null, label: "全部" },
    { value: "true", label: "通过审核" },
    { value: "false", label: "未通过审核" },
  ];
  newtabdata: any = [
    { value: 0, label: "判断题" },
    { value: 1, label: "单选题" },
    { value: 2, label: "多选题" },
    { value: 3, label: "填空题" },
    { value: 4, label: "计算题" },
    { value: 8, label: "解答题" },
    { value: 9, label: "作文题" },
    { value: 10, label: "探究题" },
    { value: 11, label: "材料题" },
    { value: 12, label: "实践题" },
    { value: 7, label: "选考单选" },
    { value: 5, label: "选考多选" },
    { value: 6, label: "选考计算" },
  ];
  selectImport(id) {
    let isHaveId = false;
    this.sisterIds.forEach((item, index, arr) => {
      if (item == id) {
        arr.splice(index, 1);
        isHaveId = true;
      }
    });
    if (!isHaveId) {
      this.sisterIds.push(id);
    }
  }
  importSisterQuestions() {
    if (this.sisterIds.length > 0) {
      this.$store
        .dispatch({
          type: "testQuestion/importSisterQuestion",
          data: {
            questionId: this.pagerequest.sisterId,
            questionType: this.pagerequest.questionType,
            sisterIds: this.sisterIds,
          },
        })
        .then((result) => {
          if (result) {
            this.$Message.warning("导入成功");
            this.$emit("save-success");
            this.$emit("input", false);
          }
        });
    } else {
      this.$Message.warning("请选择要导入的试题！");
      return false;
    }
  }
  cancel() {
    this.visibleChange(false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("save-success");
      this.$emit("input", value);
    } else {
      this.question = this.$store.state.testQuestion.sisterInfoTestQuestion;
      this.pagerequest.sisterId = this.question.sisterId;
      this.pagerequest.questionType = this.question.questionType;
      this.searchGetpage();
    }
  }
  searchGetpage() {
    this.$store.state.testQuestion.currentPage = 1;
    this.getpage();
  }
  async stateSwitching(id) {
    await this.$store.dispatch({
      type: "testQuestion/showStateSwitching",
      data: { id: id, questionType: this.pagerequest.questionType },
    });
    this.getpage();
  }
  async updateQuestion(row) {
    this.$store.commit("testQuestion/editSister", row);
    this.edit();
  }
  async deleteQuestion(id) {
    this.$Modal.confirm({
      title: "系统提示",
      content: "你确定要删除本试题？",
      okText: "是",
      cancelText: "否",
      onOk: async () => {
        await this.$store.dispatch({
          type: "testQuestion/delete",
          data: { id: id, questionType: this.pagerequest.questionType },
        });
        await this.getpage();
      },
    });
  }
  questionTypeChange(value) {
    this.pagerequest.questionType = value;
    this.$store.state.testQuestion.currentPage = 1;
    this.getpage();
  }
  cascaderSelect(value, selectedData) {
    if (value.length > 0) {
      this.pagerequest.sectionId = selectedData[selectedData.length - 1].value;
      this.pagerequest.parentName = selectedData[selectedData.length - 1].label;
    } else {
      this.pagerequest.sectionId = null;
    }
    this.getpage();
  }
  handleRefresh() {
    this.getpage();
  }
  get list() {
    return this.$store.state.testQuestion.list;
  }
  get loading() {
    return this.$store.state.testQuestion.loading;
  }
  create() {
    this.$store.state.testQuestion.editSisterQuestion.id = "";
    this.editSisterModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit("testQuestion/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("testQuestion/setPageSize", pagesize);
    this.getpage();
  }

  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "testQuestion/getAll",
      data: this.pagerequest,
    });
    //this.list;
  }

  get pageSize() {
    return this.$store.state.testQuestion.pageSize;
  }
  get totalCount() {
    return this.$store.state.testQuestion.totalCount;
  }
  get currentPage() {
    return this.$store.state.testQuestion.currentPage;
  }
  getTypeName(classTypeId) {
    for (var item of this.multiTypes) {
      if (item.id === classTypeId) return item.text;
    }
  }
  async created() {
    // this.getpage();
  }
}
